import axios from "axios";
import Storage from "@/utils/storage";
import config from "@/config/index";

const service = axios.create({
  baseURL: config.agentApiBaseUrl,
  timeout: config.timeout,
});

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    const identityToken = Storage.get("identityToken");
    if (identityToken) {
      config.headers.Authorization = `Bearer ${identityToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    const status = res.status;
    if (status && status !== 200) {
      return Promise.reject(res);
    } else {
      return res;
    }
  },
  (error) => {
    console.log(error, error.response);
    if (error && error.response && error.response.data) {
      return Promise.reject(error.response.data);
    } else {
      // other errors
      let errInfo = {
        message: "An unkown error occurred!",
        status: -9999,
      };
      return Promise.reject(errInfo);
    }
  }
);

export default service;
